import { createCRUDHook } from './createCRUDHook';
import { PartRackBinDto, HighLowDto, InventoryScreenDto } from 'utils/models';
import {
  COMPLETE_PROD_AND_CUST_ORDERITEM,
  GET_INVENTORY_SCREEN_DATA,
  TBL_PART_RACK_BIN,
  TLKP_CUSTOMER_ORDER_ITEM,
  UPDATE_RACK_BIN_DATA,
  UPDATE_WAREHOUSE_INVENTORY,
} from './apiEndPoints';

interface PartRackBinCustomOperations {
  updateWareHouseInventory: (id: number) => Promise<boolean>;
  handleHighLowData: (data: HighLowDto) => Promise<HighLowDto>;
  fetchInventoryScreenData: () => Promise<InventoryScreenDto[]>;
  completeProdAndCustOrderItem: (id: number) => Promise<boolean>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  PartRackBinDto,
  PartRackBinDto[],
  PartRackBinCustomOperations
>({
  entityName: 'PartRackBin',
  endpoint: TBL_PART_RACK_BIN,

  customOperations: (auth) => ({
    updateWareHouseInventory: async (id) => {
      const res = await auth.makeAuthenticatedGet(
        TLKP_CUSTOMER_ORDER_ITEM + UPDATE_WAREHOUSE_INVENTORY + `?partId=${id}`
      );
      return res.data;
    },

    handleHighLowData: async (data) => {
      const res = await auth.makeAuthenticatedPost(
        TLKP_CUSTOMER_ORDER_ITEM + UPDATE_RACK_BIN_DATA,
        data
      );
      return res.data;
    },

    fetchInventoryScreenData: async () => {
      const res = await auth.makeAuthenticatedGet(
        TBL_PART_RACK_BIN + GET_INVENTORY_SCREEN_DATA
      );
      return res.data;
    },

    completeProdAndCustOrderItem: async (id) => {
      const res = await auth.makeAuthenticatedGet(
        TLKP_CUSTOMER_ORDER_ITEM +
          COMPLETE_PROD_AND_CUST_ORDERITEM +
          `?orderItemId=${id}`
      );
      return res.data;
    },
  }),
});

export const PartRackBinContext = Context;
export const usePartRackBinManager = useManager;
export const usePartRackBin = useConsumer;
